/* WJW 17: use the original Reformation cart drawer, not a second drawer. */
(() => {
  'use strict';
  document.addEventListener('click', event => {
    const link = event.target.closest('a.mobile-cart-link');
    if (!link || !window.matchMedia('(max-width:749px)').matches) return;
    const nativeDrawer = document.getElementById('Cart-Drawer');
    if (!nativeDrawer) return; // Native /cart navigation remains available.
    event.preventDefault();
    const toggle = document.getElementById('cart-drawer-toggle');
    if (toggle && toggle !== link && toggle.hasAttribute('data-cart-toggle-bound')) {
      toggle.click();
      return;
    }
    // Reformation normally binds toggle on DOM ready; only use the exact same
    // native open state when the desktop/header toggle has not been bound.
    document.body.classList.add('open-cc', 'open-cart');
    nativeDrawer.classList.add('active');
    nativeDrawer.focus();
    document.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles:true }));
  });
})();
